import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { speed } from 'src/ui/common/config/animations';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
    border: 2px solid ${({ theme }) => theme.colors.softTurtle};
    background: linear-gradient(180deg, #ffb7b7 0%, #727272 100%),
        radial-gradient(60.91% 100% at 50% 0%, #ffd1d1 0%, #260000 100%),
        linear-gradient(127.43deg, #00ffff 0%, #ffffff 100%),
        radial-gradient(100.22% 100% at 70.57% 0%, #ff0000 0%, #00ffe0 100%),
        linear-gradient(64.82deg, #dbff00 0%, #3300ff 100%);
    background-blend-mode: screen, overlay, color-burn, color-dodge, normal;
`;

export const StyledContent = styled.div`
    padding: 15px 15px 30px 15px;
    font-weight: 400;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.warmBlack};

    ${media.sm`
        padding: 20px;
        font-size: 16px;
    `}

    & a span {
        color: ${({ theme }) => theme.colors.black};
        font-family: ${({ theme }) => theme.fonts.text};
    }

    & table > thead > tr > th > span {
        color: ${({ theme }) => theme.colors.blue};
        font-family: ${({ theme }) => theme.fonts.text};
        font-weight: 500;
    }

    & table > tbody > tr > td {
        color: ${({ theme }) => theme.colors.warmBlack};
    }

    & table > tbody > tr:hover {
        background: ${({ theme }) => theme.colors.softBlue};

        & td {
            color: ${({ theme }) => theme.colors.white};
        }
    }
`;

export const StyledSvgWrapper = styled.div``;

export const StyledHeading = styled(FlexBox)<{ opened: boolean }>`
    height: 46px;
    padding: 0 15px;
    background-color: ${({ theme }) => theme.colors.turtle};
    border-radius: 0;
    font-family: ${({ theme }) => theme.fonts.text};
    color: ${({ theme }) => theme.colors.text};
    font-weight: 500;
    font-size: 14px;
    width: 100%;

    ${media.sm`
        height: 60px;
        padding: 0 20px;
        font-size: 16px;
  `}

    & > * {
        width: 100%;
    }
`;

export const SeeMoreIcon = styled(SvgIcon)<{ opened: boolean }>`
    cursor: pointer;
    user-select: none;
    width: 16px;
    height: 16px;
    transform: ${({ opened }) => (opened ? 'rotate(180deg)' : 'rotate(0)')};
    transition: transform ${speed.content};

    ${media.sm`
        height: 18px;
        width: 18px;
  `}
`;
